import React, { PureComponent } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import './manage-blocks.scss';

export class ManageBlocks extends PureComponent {
  render() {
    const { blocks } = this.props;

    return (
      <div className="manage-blocks">
        <ul>
          {blocks.map((block, key) =>
            <li key={key}>
              <div className={cn('manage-block', `block-${block.type}`)}>
                <div className="manage-block-value">
                  {(block.prefix) &&
                    <span
                      className="block-prefix"
                      dangerouslySetInnerHTML={{ __html: block.prefix }}
                    />
                  }

                  <span
                    className="block-value"
                    dangerouslySetInnerHTML={{ __html: block.value }}
                  />

                  <span
                    className="block-unit"
                    dangerouslySetInnerHTML={{ __html: block.unit }}
                  />
                </div>

                <div
                  className="manage-block-text"
                  dangerouslySetInnerHTML={{ __html: block.text }}
                />
              </div>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

ManageBlocks.propTypes = {
  blocks: PropTypes.arrayOf(PropTypes.object)
};

export default ManageBlocks;



// WEBPACK FOOTER //
// ./src/components/Manage/ManageBlocks.js